import { db } from "MY_LOGIN_AND_SIGNUP/db/config";
import React, { useRef, useState, useEffect } from "react";
import firebase from "firebase/app"; // Import Firebase if not already done
import "firebase/auth"; // Import Firebase Authentication
import NotificationAlert from "react-notification-alert";
import {
    Modal,
    Button,
    FormGroup,
    Label,
    Input,
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
} from "reactstrap";

const ChangePasswordModal = ({ isOpen, toggle, notify }) => {
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showOldPassword, setShowOldPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [error, setError] = useState("");
    const [userData, setUserData] = useState(""); // Correct state handling
    const notifi = useRef(null); // Define ref properly

    useEffect(() => {
        console.log('checkuser1212');
        getUsers();
    }, []);

    const getUsers = () => {
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                let uid = user.uid;
                db.collection("zSystemUsers")
                    .get()
                    .then((querySnapshot) => {
                        let data = querySnapshot.docs.map((doc) => doc.data());
                        let currentUser = data.find(
                            (filterData) => filterData._uniqueID === uid
                        );

                        setUserData(currentUser?.username || "Profile");
                    });
            }
        });
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (newPassword.length < 6) {
            setError("Password should be at least 6 characters.");
            return;
        }
        if (newPassword !== confirmPassword) {
            setError("New password and confirm password do not match.");
            return;
        }

        const user = firebase.auth().currentUser;
        const credential = firebase.auth.EmailAuthProvider.credential(
            user.email,
            oldPassword
        );

        try {
            // Re-authenticate the user
            await user.reauthenticateWithCredential(credential);
            // Update the password
            await user.updatePassword(newPassword);
            setError(""); // Clear error on success

            // Show success notification
            if (notifi.current) {
                notifi.current.notificationAlert({
                    place: "tc",
                    message: "Password changed successfully!",
                    type: "success",
                    autoDismiss: 5,
                });
                setOldPassword("");
                setNewPassword("")
                setConfirmPassword("")
                notify("Password Changed Successfully", false);
            }
            toggle(); // Close modal
        } catch (error) {
            console.error("Password change error:", error);
            setError("Incorrect old password or an error occurred.");
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg">
            <NotificationAlert ref={notifi} />
            <div className="content">
                <Row>
                    <Col md="12">
                        <Card style={{ margin: 0 }}>
                            <CardHeader>
                                <h5 className="title">Change Password</h5>
                            </CardHeader>
                            <CardBody>
                                <form onSubmit={handleSubmit}>
                                    <Row>
                                        {/* Old Password Field */}
                                        <Col md="6">
                                            <FormGroup>
                                                <Label>Old Password</Label>
                                                <div style={{ position: "relative" }}>
                                                    <Input
                                                        type={showOldPassword ? "text" : "password"}
                                                        value={oldPassword}
                                                        onChange={(e) => setOldPassword(e.target.value)}
                                                        required
                                                        placeholder="Enter old password"
                                                    />
                                                    {/* Toggle button for Old Password */}
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            right: "10px",
                                                            top: "50%",
                                                            transform: "translateY(-50%)",
                                                            cursor: "pointer",
                                                        }}
                                                        onClick={() => setShowOldPassword(!showOldPassword)}
                                                    >
                                                        {showOldPassword ? (
                                                            <i className="fa fa-eye-slash" />
                                                        ) : (
                                                            <i className="fa fa-eye" />
                                                        )}
                                                    </div>
                                                </div>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        {/* New Password Field */}
                                        <Col md="6">
                                            <FormGroup>
                                                <Label>New Password</Label>
                                                <div style={{ position: "relative" }}>
                                                    <Input
                                                        type={showNewPassword ? "text" : "password"}
                                                        value={newPassword}
                                                        onChange={(e) => setNewPassword(e.target.value)}
                                                        required
                                                        minLength={6}
                                                        placeholder="Enter new password"
                                                    />
                                                    {/* Toggle button for New Password */}
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            right: "10px",
                                                            top: "50%",
                                                            transform: "translateY(-50%)",
                                                            cursor: "pointer",
                                                        }}
                                                        onClick={() => setShowNewPassword(!showNewPassword)}
                                                    >
                                                        {showNewPassword ? (
                                                            <i className="fa fa-eye-slash" />
                                                        ) : (
                                                            <i className="fa fa-eye" />
                                                        )}
                                                    </div>
                                                </div>
                                            </FormGroup>
                                        </Col>
                                        {/* Confirm Password Field (Always Hidden) */}
                                        <Col md="6">
                                            <FormGroup>
                                                <Label>Confirm Password</Label>
                                                <Input
                                                    type="password"
                                                    value={confirmPassword}
                                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                                    required
                                                    placeholder="Confirm new password"
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    {error && (
                                        <div style={{ color: "red", fontSize: "12px", marginBottom: "15px" }}>
                                            {error}
                                        </div>
                                    )}
                                    <div>
                                        <Button color="info" type="submit">
                                            Submit
                                        </Button>
                                        <Button onClick={()=>{
                                            setOldPassword("");
                                            setNewPassword("")
                                            setConfirmPassword("")
                                            toggle()
                                            }} style={{ marginLeft: "10px" }}>
                                            Cancel
                                        </Button>
                                    </div>
                                </form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </Modal>
    );
};

export default ChangePasswordModal;
